module.exports = __webpack_public_path__ + "static/img/zt2-pic11.6aadfcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/zt2-pic11.jpg
// module id = ojX+
// module chunks = 171